import { ModelCompareTab } from "./GettingStartedWithUniFi.types";
import { IExtendedTab } from "components/ExtendedTabs/ExtendedTabs.types";
import {
  AppVariant,
  IHeroSection,
} from "./_components/DesktopHero/DesktopHero.types";

import SwitchingImage from "./assets/tabs/compare/compact-switching.png";

import SimpleDeploymentPoster from "./assets/tour/compact/simple-deployment.jpg";
import SimpleDeploymentVideo from "./assets/tour/compact/simple-deployment.mp4";
import SimpleDeploymentNetworkVideo from "./assets/tour/compact/network.mp4";
import SimpleDeploymentProtectVideo from "./assets/tour/compact/protect.mp4";
import SimpleDeploymentAccessVideo from "./assets/tour/compact/access.mp4";
import SimpleDeploymentConnectVideo from "./assets/tour/compact/connect.mp4";

import SimpleDeploymentMobilePoster from "./assets/tour/mobile/compact/intro-1080.jpg";
import SimpleDeploymentMobileVideo from "./assets/tour/mobile/compact/intro-1080.mp4";
import SimpleDeploymentMobileNetworkVideo from "./assets/tour/mobile/compact/network-1080.mp4";
import SimpleDeploymentMobileProtectVideo from "./assets/tour/mobile/compact/protect-1080.mp4";
import SimpleDeploymentMobileAccessVideo from "./assets/tour/mobile/compact/access-1080.mp4";
import SimpleDeploymentMobileConnectVideo from "./assets/tour/mobile/compact/connect-1080.mp4";

export const SIMPLE_DEPLOYMENT_SWITCHING_TAB = {
  id: ModelCompareTab.Switching,
  label: "gettingStartedWithUniFi.compareTabs.switching",
  image: SwitchingImage,
} satisfies IExtendedTab;

export const DEPLOYMENT_HERO_SECTION = {
  id: 0,
  label: "gettingStartedWithUniFi.tabs.simpleDeployment",
  poster: SimpleDeploymentPoster,
  src: SimpleDeploymentVideo,
  tooltips: [
    {
      left: "11.9%",
      top: "26.2%",
      id: 0,
      variant: AppVariant.Network,
      description: "gettingStartedWithUniFi.hero.tooltips.network",
      video: SimpleDeploymentNetworkVideo,
    },
    {
      id: 1,
      left: "11.9%",
      bottom: "24.6%",
      variant: AppVariant.Protect,
      description: "gettingStartedWithUniFi.hero.tooltips.protect",
      video: SimpleDeploymentProtectVideo,
    },
    {
      id: 2,
      right: "7.6%",
      top: "26.2%",
      variant: AppVariant.Access,
      description: "gettingStartedWithUniFi.hero.tooltips.access",
      video: SimpleDeploymentAccessVideo,
    },
    {
      id: 3,
      right: "7.6%",
      bottom: "24.6%",
      variant: AppVariant.Connect,
      description: "gettingStartedWithUniFi.hero.tooltips.connect",
      video: SimpleDeploymentConnectVideo,
    },
  ],
} satisfies IHeroSection;

export const SIMPLE_DEPLOYMENT_MOBILE_CONFIG = {
  id: 0,
  label: "gettingStartedWithUniFi.tabs.simpleDeployment",
  poster: SimpleDeploymentMobilePoster,
  src: SimpleDeploymentMobileVideo,
  tooltips: [
    {
      bottom: "7.8%",
      left: "22%",
      id: 0,
      variant: AppVariant.Network,
      description: "gettingStartedWithUniFi.hero.tooltips.network",
      video: SimpleDeploymentMobileNetworkVideo,
    },
    {
      id: 1,
      left: "41%",
      bottom: "7.8%",
      variant: AppVariant.Protect,
      description: "gettingStartedWithUniFi.hero.tooltips.protect",
      video: SimpleDeploymentMobileProtectVideo,
    },
    {
      id: 2,
      left: "59%",
      bottom: "7.8%",
      variant: AppVariant.Access,
      description: "gettingStartedWithUniFi.hero.tooltips.access",
      video: SimpleDeploymentMobileAccessVideo,
    },
    {
      id: 3,
      left: "78%",
      bottom: "7.8%",
      variant: AppVariant.Connect,
      description: "gettingStartedWithUniFi.hero.tooltips.connect",
      video: SimpleDeploymentMobileConnectVideo,
    },
  ],
} satisfies IHeroSection;
